<template>
    <section id="sharable">
        <b-modal @hide="onHide" id="sharable-modal" ref="sharableModal" centered hide-header hide-footer :size="winWidth < 991 ? 'md': 'lg'">
            <Loader v-if="loading"/>
            <div v-else class="sharable-content mx-auto">
                <div class="content-header pt-4">
                    <button
                        @click="$store.commit('TOGGLE_MODAL', ['sharable-content', false])"
                        aria-label="Close"
                        class="close pr-3"
                        id="modal-close">
                            <Icon icon="close-modal"/>
                    </button>
                    <div class="content-wrap pb-3 d-flex justify-content-between border-bottom">
                        <div>
                            <p data-name="title">
                                Get CrossProm Info
                                <Icon icon="question" />
                            </p>
                            <p data-name="description">
                                Copy this info and post it at the end of your backers' update.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="content-body">
                    <div 
                        v-for="campaign in cpCampaignsInfo"
                        :key="`campaign-${campaign.id}`"
                        class="promo-info-sharable">
                        <div class="content-wrap">
                            <div data-name="schedule-date" class="d-flex justify-content-end">
                                <p>
                                    Scheduled Date: 
                                    <span>{{formattedDate}}</span>
                                </p>
                            </div>
                            <div data-name="campaign-info" class="position-relative">
                                    <div class="position-absolute d-flex align-items-center justify-content-center">
                                        <Thumbnail 
                                            class-name="mr-2"
                                            :data = "campaign"
                                            size = "small" />
                                        <p>Spot {{campaign.spotPosition}}</p>
                                    </div>
                            </div>
                            <div data-name="promo-title">
                                <p>{{campaign.promo_title}}</p>
                            </div>
                            <div 
                                v-if="campaign.promo_image && campaign.promo_image.length"
                                data-name="promo-image">
                                    <div class="position-absolute">
                                        <Icon icon="download-icon" @click.native="download(campaign.promo_image, campaign.title)"/>
                                    </div>
                                    <img 
                                        class="w-100"
                                        :src="campaign.promo_image"
                                        alt="">
                            </div> 
                            <div data-name="promo-desc">
                                <p>
                                    {{campaign.promo_desc}}
                                </p>
                            </div>   
                            <div data-name="gets-your" class="mt-3" v-if="inPremium">
                                <a :href="campaign.link" target="_blank">
                                    <p>
                                        Get yours here!
                                    </p>
                                </a>
                            </div> 
                            <div data-name="promo-footer" v-if="inPremium">
                                <p>Hyperlink the title, image and CTA with this link</p>
                                <div class="hint-pointer">
                                    <img src="/img/1x_Pointing_Hand.png" alt="">
                                </div>
                                <div data-name="url-wrapper">
                                    <div class="input-wrapper">
                                        <Icon icon="url-icon"/>
                                        <input 
                                            type="text" 
                                            disabled 
                                            :value="campaign.link">
                                    </div>
                                    <Button 
                                        v-b-tooltip.hover 
                                        :title="copied? 'copied': 'copy'" 
                                        @click.native="copy(campaign.id, campaign.title)"
                                        type="copy">
                                            Copy
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-footer">
                    <button 
                        v-b-tooltip.hover
                        title="Clicking this button saves information about your crossprom partner to the Kickstarter update draft. NOTE: with Basic plan you can only use this feature once."
                        @click="saveData"
                        type="button" 
                        class="btn btn-green mx-auto d-block">
                        Save Draft on Kickstarter
                    </button>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
import moment from 'moment'
import Button from '../components/Theme/Button.vue'
import Icon from '../components/Theme/Icon'
import Thumbnail from '../components/Theme/Thumbnail'
import {Loader} from '@/components/Icons'
import {onMounted, computed, ref} from '@vue/composition-api'
import {useCpInfo, useStore, useRouter} from '../core/hooks'

export default {
    name: 'SharableContent',
    components: {
        Button,
        Icon,
        Thumbnail,
        Loader
    },
    setup(props, {root}){
        const {store, state} = useStore()
        const {router} = useRouter()
        const updateData = state.value.modals['sharable-content']
        const inPremium = computed(() => store.getters.inPremium)

        const {
            cpCampaignsInfo,
            campaignData,
            getPromoInfo,
            saveDraftOnKickstarter,
            formattedDate,
            loading,
            canPostUpdate
        } = useCpInfo(updateData, true)

        const winWidth = computed(() => window.innerWidth)

        onMounted(() => {
            root.$bvModal.show(`sharable-modal`)
            getPromoInfo()
        })

        const copied = ref(false)

        const onHide = (evt) => {
            setTimeout(() => {
                store.commit('TOGGLE_MODAL', ['sharable-content', false])
            }, 0)
        }

        const hide = (callback = () => {}) => {
            root.$bvModal.hide('sharable-modal')
            setTimeout(() => {
                store.commit('TOGGLE_MODAL', ['sharable-content', false])
                callback()
            }, 0)
        }

        const download = async (url, title) => {

            const link = document.createElement('a')
            link.href = url
            link.download = Date.now()

            if(url.startsWith('https')) {
                // fetch only for https images for prevent CORS not secure error
                const response = await fetch(url)
                const blob = await response.blob()
                link.href = URL.createObjectURL(blob)
            } else {
                link.target = '_blank'
            }

            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)

            root.$ga.event('Crossprom Info', 'Download Pic', 'Campaign', title)
            root.$sendMixpanelEvent('Crossprom Info Modal', {
                'Action': 'Download Pic',
                'Campaign Name': title
            })
        }


        const exportHtml = () => {
            let html = ''
            let el = document.createElement('input')      
            cpCampaignsInfo.value.forEach(doc => {
                let exp_html = '<p><a target="_blank" href="$link"><strong>$title</strong></p><a target="_blank" href="$link"><figure><img alt="" src="$img_src"></figure></a><p>$description</p> <a target="_blank" href="$link"><strong>Get it now</strong></a>'
                // exp_html = exp_html.replace('$link', this.promo_link)
                exp_html = exp_html.replace('$title', doc.promo_title)
                exp_html = exp_html.replace('$description', doc.promo_desc)
                exp_html = exp_html.replace('$img_src', doc.promo_image)
                html += exp_html
            })
            el.value = html
            document.body.appendChild(el)
            el.select()
            el.focus()
            document.execCommand('copy')
            document.body.removeChild(el)
            this.copied = true
            setTimeout(() => {
                this.copied = false
            }, 2000);
        }


        const copy = (campId, title) => {
            let el = document.createElement('input')  
            el.value = campaignData.value.crossprom_urls[campId]
            document.body.appendChild(el)
            el.select()
            el.focus()
            document.execCommand('copy')
            document.body.removeChild(el)  
            copied.value = true  
            setTimeout(() => {
                copied.value = false 
            }, 2000);

            root.$ga.event('Crossprom Info', 'Copy Link', 'Campaign', title)
            root.$sendMixpanelEvent('Crossprom Info Modal', {
                'Action': 'Copy Link',
                'Campaign Name': title
            })
        }

        const onCloseIconClick = () => {
            root.$emit('openedSide', false)
        }

        const sendEvents = () => {
            root.$ga.event('Post Update', 'Save To Kickstarter Clicked', `
                Location: Crossprom Info Modal,
                Campaign: ${campaignData.value.title},
                UpdateDateId: ${updateData.id},
                UpdateDate: ${formattedDate.value},
                Has Premium: ${inPremium.value}
            `)

            root.$sendMixpanelEvent('Save To Kickstarter Clicked', {
                'Location': 'Crossprom Info Modal',
                'Campaign Name': campaignData.value.title,
                'Update Date Id': updateData.id,
                'Update Date': formattedDate.value,
                'Has Premium': inPremium.value
            });
        }

        const saveData = async () => {

            const canPost = await canPostUpdate()

            if(!canPost && !updateData.kickstarterDraftUrl){
                return router.push({
                    path: '/pricing'
                })
            }
            saveDraftOnKickstarter()
            sendEvents(true)
            hide()
        }

        return {
            cpCampaignsInfo,
            saveData,
            loading,
            formattedDate,
            winWidth,
            onHide,
            inPremium,
            copy,
            copied,
            download

        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables';
div.sharable-content {
    width: 776px;
    background: #FFFFFF;
    box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    overflow-y: auto;

    div.content-wrap {
        width: 696px;
        margin: 0 auto;
    }

    div.content-header {
        div.content-wrap {
            p[data-name="title"] {
                font-size: $h4;
                font-weight: $weight_bold;
                color: $c7;
            }
            p[data-name="description"] {
                font-size: $p4;
                color: $c7;
                line-height: 19px;
            }
            button[type="primary"] {
                width: 150px;
            }
        }
    }
    div.content-body {
        padding-bottom: 32px;
        div[data-name="schedule-date"] {
            margin-top: 5px;
            p {
                color: $c8;
                font-size: $p4;
                span {
                    font-size: $p4;
                    color: $c6;
                    font-weight: $weight_bold;
                }
            }
        }
        div[data-name="campaign-info"] {
            height: 10px;
            background: $c24;
            div {
                width: 100px;
                left: 21px;
                background: $c14;
                top: -100%;
                transform: translateY(5%);
                img {
                    width: 28px;
                    height: 28px;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 1px solid $c25;
                }
                p {
                    text-transform: uppercase;
                    color: $c8;
                    font-size: $p5;
                    font-weight: $weight_bold;
                    margin: 0;
                }

            }
        }
        div[data-name="promo-title"] {
            margin-top: 20px;
            p {
                font-size: $p2;
                font-weight: $weight_bold;
                color: $c6;
            }
        }
        div[data-name="promo-image"] {
            position: relative;
            div.position-absolute {
                right: 10px;
                top: 10px;

                img {
                    opacity: 0.85;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    &:hover {
                        opacity: 1;
                    }
                }
            }
        }
        div[data-name="promo-desc"] {
            margin-top: 20px;
            p {
                font-size: $p3;
                line-height: 24px;
                color: $c7;
            }
        }
        div[data-name="gets-your"] {
            p {
                color: $c7;
                font-size: $p3;
                cursor: pointer;
            }
        }
        div[data-name="promo-footer"] {
            height: 120px;
            background: $c1;
            border-bottom-left-radius: 15px;
            border-bottom-right-radius: 15px;
            padding: 24px 56px 24px 56px ;
            position: relative;
            p {
                color: $c11;
                font-size: $p3;
                font-weight: $weight_600;
                text-align: center;
                margin: 0;
            }
            div.hint-pointer {
                position: absolute;
                width: 45px;
                height: 50px;
                z-index: 100;
                right: 0;
                top: -20px;
                animation: anim 1s ease infinite;

                @keyframes anim {
                    50% {
                        right: 20px;
                        top: 0;
                    }
                }

            }
            div[data-name="url-wrapper"] {
                height: 40px;
                border: 1px solid $c14;
                border-radius: 8px;
                margin-top: 8px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;

                div.input-wrapper {
                    height: 20px;
                    padding-left: 16px;
                    display: flex;
                    align-items: center;
                    input {
                        padding-left: 8px;
                        margin-left: 8px;
                        background: transparent;
                        border: 0;
                        border-left: 1px solid $c14;
                        color: $c14;
                    }
                }
            }
            
        }
    }
    div.content-footer{
        border-top: 1px solid $c4;
        padding: 32px 0;
    }
}
@media (max-width: 991px) {
    div.sharable-content {
        width: 500px;
        
        div.content-wrap {
            width: 450px;
        }
    }
}
</style>